// extracted by mini-css-extract-plugin
export default {"header-wrapper":"TrocarPlanos_header-wrapper__NED1T","grid-wrapper":"TrocarPlanos_grid-wrapper__IG8Mo"};